import { fetchReducerGenerator } from 'redpoints-front-common/reducers';

import {
  AUDIT_RESULTS_CLEAR,
  AUDIT_RESULTS_CREATE_INCIDENTS,
} from '../../../../actions/actionTypes';

const createIncidents = fetchReducerGenerator(
  AUDIT_RESULTS_CLEAR,
  AUDIT_RESULTS_CREATE_INCIDENTS
);

export default createIncidents;
